import { useEffect, useState } from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../lib/supabase'

const navItems = [
  { to: '/', label: 'Dashboard', icon: '▣', exact: true },
  { to: '/indicadores', label: 'Indicadores', icon: '◈' },
  { to: '/fcas', label: 'FCAs', icon: '◎' },
]
const analyticsItems = [
  { to: '/analytics/aderencia', label: 'Histórico de Aderência', icon: '◑' },
  { to: '/analytics/fcas', label: 'Analytics FCAs', icon: '◎' },
]
// Só para admin/super_admin — a rota é protegida por AdminRoute em App.js
const analyticsAdminItems = [
  { to: '/analytics/metas', label: 'Meta Analytics', icon: '◈' },
]
const adminItems = [
  { to: '/gestores', label: 'Usuários', icon: '◉' },
  { to: '/reunioes', label: 'Reuniões', icon: '◷' },
  { to: '/whatsapp', label: 'WhatsApp', icon: '◈' },
  { to: '/logs', label: 'Logs', icon: '◎' },
]
const superAdminItems = [
  { to: '/empresas', label: 'Empresas', icon: '🏢' },
]

const ROLE_BADGE = {
  super_admin: { label: 'Super Admin', cls: 'badge-blue' },
  admin: { label: 'Admin', cls: 'badge-blue' },
  gestor: { label: 'Gestor', cls: 'badge-gray' },
  coordenador: { label: 'Coordenador', cls: 'badge-amber' },
}

export default function Layout() {
  const { profile, isAdmin, isSuperAdmin, selectedCompany, setSelectedCompany, signOut } = useAuth()
  const navigate = useNavigate()
  const [companies, setCompanies] = useState([])

  useEffect(() => {
    if (!isSuperAdmin) return
    supabase.from('companies').select('id, nome').order('nome')
      .then(({ data }) => setCompanies(data || []))
  }, [isSuperAdmin])

  async function handleSignOut() {
    await signOut()
    navigate('/login')
  }

  const roleBadge = ROLE_BADGE[profile?.role] || { label: profile?.role, cls: 'badge-gray' }
  const showAdminSection = isAdmin || isSuperAdmin

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <aside style={{
        width: 220, flexShrink: 0,
        background: 'var(--surface)', borderRight: '1px solid var(--border)',
        display: 'flex', flexDirection: 'column',
        padding: '20px 0'
      }}>
        {/* Logo */}
        <div style={{ padding: '0 20px 16px', borderBottom: '1px solid var(--border)', marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 32, height: 32, borderRadius: 8,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 24, flexShrink: 0
            }}>📊</div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 13 }}>Indicadores</div>
              <div style={{ fontSize: 11, color: 'var(--text3)' }}>
                {isSuperAdmin
                  ? (selectedCompany?.nome || 'Todas as empresas')
                  : 'Enterplak / RwTech'}
              </div>
            </div>
          </div>

          {/* Seletor de empresa — só para super_admin */}
          {isSuperAdmin && (
            <select
              value={selectedCompany?.id || ''}
              onChange={e => {
                const found = companies.find(c => c.id === e.target.value)
                setSelectedCompany(found || null)
              }}
              style={{ width: '100%', marginTop: 10, fontSize: 12 }}
            >
              <option value="">Todas as empresas</option>
              {companies.map(c => (
                <option key={c.id} value={c.id}>{c.nome}</option>
              ))}
            </select>
          )}
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '0 8px' }}>
          {navItems.map(item => (
            <NavLink key={item.to} to={item.to} end={item.exact}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '8px 12px', borderRadius: 'var(--radius-sm)',
                marginBottom: 2, textDecoration: 'none', fontSize: 13, fontWeight: 500,
                color: isActive ? 'var(--blue)' : 'var(--text2)',
                background: isActive ? 'var(--blue-bg)' : 'transparent',
                transition: 'all 0.15s',
              })}>
              <span style={{ fontSize: 14 }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}

          <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', padding: '12px 12px 4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            Analytics
          </div>
          {analyticsItems.map(item => (
            <NavLink key={item.to} to={item.to}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '8px 12px', borderRadius: 'var(--radius-sm)',
                marginBottom: 2, textDecoration: 'none', fontSize: 13, fontWeight: 500,
                color: isActive ? 'var(--blue)' : 'var(--text2)',
                background: isActive ? 'var(--blue-bg)' : 'transparent',
                transition: 'all 0.15s',
              })}>
              <span style={{ fontSize: 14 }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
          {showAdminSection && analyticsAdminItems.map(item => (
            <NavLink key={item.to} to={item.to}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '8px 12px', borderRadius: 'var(--radius-sm)',
                marginBottom: 2, textDecoration: 'none', fontSize: 13, fontWeight: 500,
                color: isActive ? 'var(--blue)' : 'var(--text2)',
                background: isActive ? 'var(--blue-bg)' : 'transparent',
                transition: 'all 0.15s',
              })}>
              <span style={{ fontSize: 14 }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}

          {showAdminSection && (
            <>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', padding: '12px 12px 4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Admin
              </div>
              {adminItems.map(item => (
                <NavLink key={item.to} to={item.to}
                  style={({ isActive }) => ({
                    display: 'flex', alignItems: 'center', gap: 10,
                    padding: '8px 12px', borderRadius: 'var(--radius-sm)',
                    marginBottom: 2, textDecoration: 'none', fontSize: 13, fontWeight: 500,
                    color: isActive ? 'var(--blue)' : 'var(--text2)',
                    background: isActive ? 'var(--blue-bg)' : 'transparent',
                    transition: 'all 0.15s',
                  })}>
                  <span style={{ fontSize: 14 }}>{item.icon}</span>
                  {item.label}
                </NavLink>
              ))}
            </>
          )}

          {isSuperAdmin && (
            <>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text3)', padding: '12px 12px 4px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Sistema
              </div>
              {superAdminItems.map(item => (
                <NavLink key={item.to} to={item.to}
                  style={({ isActive }) => ({
                    display: 'flex', alignItems: 'center', gap: 10,
                    padding: '8px 12px', borderRadius: 'var(--radius-sm)',
                    marginBottom: 2, textDecoration: 'none', fontSize: 13, fontWeight: 500,
                    color: isActive ? 'var(--blue)' : 'var(--text2)',
                    background: isActive ? 'var(--blue-bg)' : 'transparent',
                    transition: 'all 0.15s',
                  })}>
                  <span style={{ fontSize: 14 }}>{item.icon}</span>
                  {item.label}
                </NavLink>
              ))}
            </>
          )}
        </nav>

        {/* Version */}
        <div style={{ padding: '0 16px 8px', textAlign: 'center' }}>
          <span style={{ fontSize: 10, color: 'var(--text3)' }}>v2.0.4</span>
        </div>

        {/* User info */}
        <div style={{ padding: '12px 16px', borderTop: '1px solid var(--border)' }}>
          <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 1 }}>{profile?.nome}</div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span className={`badge ${roleBadge.cls}`}>{roleBadge.label}</span>
            <button className="btn btn-ghost btn-sm" onClick={handleSignOut} style={{ fontSize: 12 }}>
              Sair
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex: 1, padding: '32px', overflow: 'auto', background: 'var(--bg)' }}>
        <div className="container fade-in">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
